import {
  ShieldCheck,
  Clock,
  Users,
  ScrollText,
  Globe2,
  BadgeIndianRupee,
} from "lucide-react";

const items = [
  {
    icon: Clock,
    title: "24/7 dedicated support",
    body: "A human at every hour. No IVR trees, no chatbots. Direct line to your named advisor and their standby.",
  },
  {
    icon: BadgeIndianRupee,
    title: "Competitive prices",
    body: "IATA rates, GST-clean invoices and negotiated corporate fares — with no hidden markups or surprise charges.",
  },
  {
    icon: ScrollText,
    title: "Policy compliance built in",
    body: "Every booking is checked against your travel and expense policy before it is confirmed. Auditable trail included.",
  },
  {
    icon: ShieldCheck,
    title: "Safe & reliable travel",
    body: "Live traveller tracking, geo-fenced risk alerts and vetted vendors. Your safety and satisfaction are our top priority.",
  },
  {
    icon: Users,
    title: "Dedicated account team",
    body: "Not a queue. A named advisor, a backup, and a director who knows your organisation's cadence.",
  },
  {
    icon: Globe2,
    title: "Best options, wide reach",
    body: "Wide range of destinations and preferred timings — from Chennai to forty-two capitals, all under one platform.",
  },
];

export default function WhyChooseUs() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-24 sm:py-32 bg-white border-t border-[#4A1D96]/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14 reveal">
          <span className="uppercase tracking-[0.28em] text-xs text-[#F97316] font-semibold">
            Why Celesta
          </span>
          <h2
            data-testid="why-heading"
            className="mt-4 font-serif text-4xl sm:text-5xl leading-[1.05] text-[#1B0F3A]"
          >
            Six reasons finance
            <br />
            leaders keep us{" "}
            <span className="brand-gradient italic font-medium">on retainer.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0 border-t border-l border-[#4A1D96]/10">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={it.title}
                data-testid={`why-item-${i}`}
                className="reveal group p-8 lg:p-10 border-r border-b border-[#4A1D96]/10 bg-white hover:bg-[#FFF8F1] transition-colors duration-500"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-[#F3EBFF] text-[#4A1D96] group-hover:bg-[#F97316] group-hover:text-white transition-colors">
                  <Icon size={22} strokeWidth={1.75} />
                </div>
                <h3 className="mt-6 font-serif text-2xl text-[#1B0F3A]">
                  {it.title}
                </h3>
                <p className="mt-4 text-[#3B2A5B]/80 leading-relaxed text-[0.95rem]">
                  {it.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
